// extracted by mini-css-extract-plugin
export default {"container":"FallbackLoader_container__KETrj"};